export default class team{
	constructor($scope,
				$routeParams,
				method,
				teamService,
				$location,
                $uibModal,
				toastr,
                proyectosService
				){
		this.scope    = $scope;
		this.location = $location;
		this.toastr = toastr;
        this.modal = $uibModal;
        this.scope.cliente = localStorage.getItem('cliente');
		switch (method) {
			case 'list':
				this.list(teamService);
			break;
			case 'new':
				this.create(teamService,proyectosService);
			break;
			case 'view':
				this.view($routeParams,
                    teamService,proyectosService);
			break;
		}
	}

	list(teamService){

        let self = this.scope;
        teamService.getAll().then((resp, err) => {
			self.teams = resp.data.message;
		});

        self.getItemPage = (item) => {
            let index = self.teams.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, teamService);
        
	}

	create(teamService,proyectosService){

        this.scope.aux   = {
            availableUsers: {
                options: {
                    leftContainerLabel: 'Integrantes Disponibles',
                    rightContainerLabel: 'Integrantes Seleccionados',
                    active: true
                },
                izquierda: [],
                derecha: [],
                removeVal: []
            }
        };

        teamService.getAvailableUsers().then((resp, err) => {
            this.scope.aux.availableUsers.izquierda = resp.data.message;
            this.scope.aux.availableUsers.derecha = [];
        });

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if(typeof this.scope.team.proyecto === 'undefined') {
                this.scope.inAction = false;
                this.toastr.error('Error', 'Debe seleccionar un proyecto', {
                    timeOut: 2000,
                    closeButton: true
                });
                return;
            }

            if (!this.scope.inAction && this.scope.aux.availableUsers.derecha.length > 0) {
                this.scope.inAction = true;
                this.scope.team.integrantes = this.scope.aux.availableUsers.derecha;
                teamService.save(this.scope.team).then((resp) => {
                    this.toastr.success('Team creado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/team');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al crear el team!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
        };
        
        proyectosService.getAll().then((resp, err) => {
            if (!err) {
                this.scope.proyectos = resp.data.message;
            }
        });
	}

	view($routeParams,
         teamService, proyectosService){

        this.scope.aux   = {
            availableUsers: {
                options: {
                    leftContainerLabel: 'Integrantes Disponibles',
                    rightContainerLabel: 'Integrantes Seleccionados',
                    active: true
                },
                izquierda: [],
                derecha: [],
                removeVal: []
            }
        };

        teamService.getById({_id: $routeParams.id}).then((resp) => {
			this.scope.team = resp.data.message;
            let der =  angular.isDefined(this.scope.team.integrantes) ? this.scope.team.integrantes : [];
            let id_der = [];

            for (var el in der) {
                let element = der[el];
                id_der.push(element._id);
            }
            this.scope.aux.availableUsers.derecha = der;

            teamService.getAvailableUsers().then((resp, err) => {
                let toFilter = resp.data.message;
                let filter = [];
                for (var el in toFilter) {
                    let element = toFilter[el];
                    if (id_der.indexOf(element._id) < 0) {
                        filter.push(element);
                    }
                }
                this.scope.aux.availableUsers.izquierda = filter;
            });
		}).catch((er) => {
			console.log(er);
		});


        this.scope.inAction = false;
		this.scope.guardar = () => {

            if(typeof this.scope.team.proyecto === 'undefined') {
                this.scope.inAction = false;
                this.toastr.error('Error', 'Debe seleccionar un proyecto', {
                    timeOut: 2000,
                    closeButton: true
                });
                return;
            }
            
            if (!this.scope.inAction && this.scope.aux.availableUsers.derecha.length > 0) {
                this.scope.inAction = true;
                this.scope.team.integrantes = this.scope.aux.availableUsers.derecha;
                teamService.update(this.scope.team).then((resp) => {
                    this.toastr.success('Team modificado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/team');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar el team!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
        };
        
        proyectosService.getAll().then((resp, err) => {
            if (!err) {
                this.scope.proyectos = resp.data.message;
            }
        });
	}

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Team</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar al team: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.teams.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Team eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar al Team!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}



// WEBPACK FOOTER //
// ./app/js/controllers/team/team.js